module.exports = __webpack_public_path__ + "img/BlueWhiteGrayFooter.7c1ec96a.jpg";